import { useNavigate } from 'react-router-dom'
import { GitMerge } from 'lucide-react'
import {
  isMainBranch,
  useActiveBranch,
  useActiveBranchRecord
} from '@axilon-apps/domains-ontology-ui-state'
import { Button } from '../ui/button'

/**
 * Topbar Merge action for the active branch: bring its committed work into a
 * target (default main). Navigates to the merge review page (preview-first,
 * resolve-inline) rather than opening a modal. Hidden on main — main is the
 * baseline merge target, not a source. A protected branch still merges (a
 * protected source is read, never consumed), so the action stays available.
 */
export function BranchMergeButton() {
  const navigate = useNavigate()
  const activeId = useActiveBranch()
  // Resolve by id (page-independent) — the active branch can sit off the
  // paginated first page, where a list scan would wrongly find nothing.
  const active = useActiveBranchRecord()

  // On the baseline (no active id) or main's own row: nothing to merge from.
  if (!activeId || (active !== undefined && isMainBranch(active))) return null
  const mergeable = active !== undefined

  return (
    <Button
      variant="outline"
      size="sm"
      className="h-8 gap-1.5 text-xs"
      disabled={!mergeable}
      title={mergeable ? undefined : 'Switch to a branch to merge it'}
      onClick={() => navigate(`/branches/merge?source=${encodeURIComponent(activeId)}`)}
    >
      <GitMerge className="size-3.5" />
      Merge
    </Button>
  )
}
